import React from "react";
import styles from "./CTABanner.module.css";

const WHATSAPP_NUMBER = "971567575811";

function CTABanner() {
  const whatsappLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    "Hi Tripontourism! I'd like to book a Desert Safari trip."
  )}`;

  const handleViewPackages = (e) => {
    e.preventDefault();
    const target = document.getElementById("packages");
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section className={styles.section}>
      <div className={`container ${styles.inner}`}>
        <h2 className={styles.title}>Ready for the Adventure of a Lifetime?</h2>
        <p className={styles.subtitle}>
          Limited spots available for tonight's sunset safari. Reserve yours
          in under a minute.
        </p>

        <div className={styles.actions}>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.primaryBtn}
          >
            Book via WhatsApp
          </a>
          <a
            href="#packages"
            onClick={handleViewPackages}
            className={styles.secondaryBtn}
          >
            View Packages
          </a>
        </div>
      </div>
    </section>
  );
}

export default CTABanner;
